import React from "react";

import classes from "../equipmentSets/EquipmentSetsIndex.module.scss";

const CharacterSetsIndex = () => {
  return (
    <div className={classes.placeholder}>
      <p>Select a character base set on the left to review CDN sprites and missing assets.</p>
    </div>
  );
};

CharacterSetsIndex.displayName = "CharacterSetsIndex";

export default CharacterSetsIndex;
